/*jshint esversion: 9 */
/*jshint sub:true*/
import { mapGetters, mapActions, mapState } from 'vuex';

// //draco import
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
// // raycast
import {
  acceleratedRaycast,
  computeBoundsTree,
  disposeBoundsTree,
//   // CONTAINED,
//   // INTERSECTED,
//   // NOT_INTERSECTED,
} from 'three-mesh-bvh';

// // import { ConvexGeometry } from 'three/examples/jsm/geometries/ConvexGeometry.js';

import {
AmbientLight,
DirectionalLight,
PerspectiveCamera,
Scene,
WebGLRenderer,
GridHelper,
AxesHelper,

Color,
// // plan test
// SphereGeometry,
DoubleSide,
Mesh,
// Vector2,
// Shape,
// ExtrudeGeometry,
// Raycaster,
BufferGeometry,
Group,

MeshLambertMaterial,

BufferAttribute,
//fpv test
// EdgesGeometry,
LineBasicMaterial,
LineLoop,
// Line,
Vector3,
// LineSegments

} from "three";

// import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';

import * as THREE from 'three';

import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

// import { IfcDisplayMixin } from '@/mixins/IfcDisplay.mixin.js';
// import { IfcDrawingMixin } from '@/mixins/IfcDrawing.mixin.js';
// import { IfcPlansMixin } from '@/mixins/IfcPlans.mixin.js';
// import { IfcRayCastingMixin } from '@/mixins/IfcRayCasting.mixin.js';
// import { IfcGeometryMixin } from '@/mixins/IfcGeometry.mixin.js';
// import { IfcSectionsMixin } from '@/mixins/IfcSections.mixin.js';
// import { log10 } from 'mathjs';

export const IfcInitializeMixin = {
  mixins: [
    // IfcRayCastingMixin,
    // IfcPlansMixin,
    // IfcDrawingMixin,
    // IfcDisplayMixin,
    // IfcGeometryMixin,
    // IfcSectionsMixin,
  ],
  components: {
  },
  data: () => ({
    renderer: '',
    scene: '',
    size: '',
    camera: '',
    model: {},
    ifcLoader: '',
    count: 0,
    count_done: 0,
    plan: false,
    elements_by_takting_id: {},
    edges_elements_by_takting_id: {},
    highlight_material: {},
    transparent_material: {},
    points_material: {},
    shape_material: {},
    drawing: false,
    drawing_plane: {},
    drawing_cursor: {},
    drawing_object: {
      // lower_level: 0,
      // height: 2,
      // path: [
      //   {x: 0, y: 0},
      //   {x: 1, y: 0},
      //   {x: 1, y: 1},
      //   {x: 0, y: 1},
      // ],
      // shape: {},
      // material: {},
    },
    selected_shape_train_id: -1,
    selected_shape_taktarea_id: -1,
    //center model
    center_model: false,
    center_position: '',
    //visibility handling
    active_element_ids: [],
    show_invisible: false,
    hide_non_selected: false,
    show_elements_by_takt: false,
    show_edges: false,
    show_edges_only: false,
    //fpv test
    projection_type: '3D',
    is_fpv: false,
    clock: {},
    player: {},
    other_players: {},
    playerIsOnGround: false,
    playerVelocity: {},
    upVector: {},
    tempVector: {},
    tempVector2: {},
    tempBox: {},
    tempMat: {},
    tempSegment: {},
    fwdPressed: false,
    bkdPressed: false,
    rgtPressed: false,
    lftPressed: false,
    collider: {},
    fpv_params: {
      firstPerson: false,
      displayCollider: false,
      displayBVH: false,
      visualizeDepth: 10,
      gravity: - 30,
      playerSpeed: 10,
      physicsSteps: 5,
      reset: {},
    },
    model_is_loading: false,
    model_loading_percantage: 0,

    //IFC Drawing
        //cursor
        cursor: {
          show: false,
        },
        cursor_sphere: {}, //mesh
        handle_sphere: {}, //mesh
        //generic movings point
        moving_point: false,
        zero_plane: {}, //plane
        fixed_z_plane: {},
        fixed_z_value: 1,
        use_fixed_z: false,

        edit_geometry_object: {id: -1},
        raycast_object_name_cache: "",

        edit_geom_point_index: -1,

        edit_geom_mesh: {},
        edit_geom: {},
        edit_unstaged_geometry: {},
        edit_geom_point_cache: {x: 0, y: 0},
        create_geom_mode: false,
    
    // IFC Raycasting
        intersected_id: -1,
        intersected_name: "",
        intersected_face: {},
        mouse: {},
        raycaster: {},
        moved: false,
        raycast_object: '',
        window_mouse_down: false,

        magnetic_corner_test: false,
      // initialze meshes
      mesh_names: [],
      edges_mesh_names: [],
      all_groups: {},
      all_normal_groups: {},
      visible_normal_group: {},
      selected_normal_group: {},
      highlighted_normal_group: {},

      // colored edges
      all_edges_groups: {},
      visible_edges_group: {},
      selected_edges_group: {},
      taktarea_elements_edges_group: {},
      step_elements_edges_group: {},
      highlighted_edges_group: {},

      transparent_group: {},
      plans_group: {},
      points_helper_group: {},
      edges_helper_group: {},
  
      //unstaged visibility
      edges_unstaged_ids: [],
      visible_unstaged_ids: [],
      selected_unstaged_ids: [],
      highlighted_unstaged_ids: [],

      // clipping
      clipping_planes: [],
      clipping_plane_hor: {},
      clipping_plane_ver_x: {},
      clipping_plane_ver_y: {},
      show_section_ver_x: false,
      show_section_ver_y: false,
      show_section_hor: false,
      invert_section_ver_x: false,
      invert_section_ver_y: false,
      invert_section_hor: false,

      // mouse shape selection
      startX: - Infinity,
      startY: - Infinity,
    
      prevX: - Infinity,
      prevY: - Infinity,

      tempVec0: new THREE.Vector2(),
      tempVec1: new THREE.Vector2(),
      tempVec2: new THREE.Vector2(),

      selectionPoints: [],
      shape_selection_dragging: false,
      selectionShapeNeedsUpdate: false,
      selectionNeedsUpdate: false,
      selectionShape: {},
      shape_selection_mode: 'box',
      shape_selection_live_update: false,


      //Orbit Controls
      sphereGroup: {},
  }),

  computed: {
    ...mapGetters('ProjectStructure', [
      'getIFCItems',
      'getAllChildElements',
    ]),
    ...mapGetters('ProjectCalendar', [
      'getCurrentTaktIndex'
    ]),
    ...mapGetters('Auth', [
      'getUserLiveSync',
    ]),
    ...mapGetters('Project', [
      'getProjectLength'
    ]),
    ...mapState('ProjectStructure', [
      'visible_elements'
    ]),
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects',
    ]),
  },
  methods: {
    ...mapActions(
      'ProjectStructure', [
      'importIFC',
      'requestChildrenIds',
      'setCollectionObjects',
      'requestElementsByTakt',
      'showElementsByTakt',
      'uploadPlan',
      'removePlanFromParent',
    ]
    ),
    ...mapActions('Project', [
      'addUnstagedElementId',
      'removeUnstagedElementId',
    ]),
    initializeScene() {
      console.log('initializing the scene');
      this.initializeMaterials();

      this.model_is_loading = true;
      this.scene = new Scene();

      //Object to store the size of the viewport
      // let content_el = document.getElementById("bim-preview-background");
      // let content_el = this.$refs.canvas;
      // console.log(content_el);

      this.size = {
        width: this.$refs.canvas.offsetWidth,
        height: this.$refs.canvas.offsetHeight,
      };
      // console.log(this.size);

      // Creates the camera (point of view of the user)
      // Make sure camera has usefull settings!
        this.camera = new PerspectiveCamera(75, this.size.width / this.size.height);
        this.camera.position.set(0, 0, 1);
        this.camera.updateProjectionMatrix();
        this.camera.up.set(0,0,1);
        this.scene.add( this.camera );
        // console.log(this.camera);

        // mouse selection shape
        //! Stört Definition des Drehpunktes über Doppelklick
          // this.selectionShape = new THREE.Line();
          // this.selectionShape.material.color.set( 0xff9800 ).convertSRGBToLinear();
          // this.selectionShape.renderOrder = 1;
          // this.selectionShape.position.z = - .2;
          // this.selectionShape.depthTest = false;
          // this.selectionShape.scale.setScalar( 1 );
          // this.camera.add( this.selectionShape );


        //Creates the lights of the scene
        const lightColor = 0xffffff;
        const ambientLight = new AmbientLight(lightColor, 0.5);
        this.scene.add(ambientLight);
        const directionalLight = new DirectionalLight(lightColor, 1);
        directionalLight.position.set(0, 0, 10);
        directionalLight.target.position.set(-5, 0, 0);
        this.scene.add(directionalLight);
        this.scene.add(directionalLight.target);
        // console.log(directionalLight);


      //Sets up the renderer, fetching the canvas of the HTML
      this.renderer = new WebGLRenderer({ antialias: true, alpha: true });
      this.renderer.setClearColor(0xffffff);

      // const threeCanvas = document.getElementById("three-canvas");
      this.$refs.canvas.appendChild(this.renderer.domElement);
      // document.getElementById('bim-preview-background').appendChild(this.renderer.domElement);
      const threeCanvas = this.renderer.domElement;
      // console.log(threeCanvas);
      threeCanvas.setAttribute('tabindex', '0');
      // console.log(this); // Sollte die Vue-Instanz anzeigen
      // console.log(this.onKeyDown); // Sollte die onKeyDown-Methode anzeigen
      threeCanvas.addEventListener('keydown', this.onKeyDown.bind(this));
      threeCanvas.addEventListener('click', () => {
        threeCanvas.focus();
      });

      // console.log('Test');
      // threeCanvas.tabindex = 0;
      // threeCanvas.focus();
      // this.renderer = new WebGLRenderer({ canvas: threeCanvas, antialias: true, alpha: true });
      this.renderer.setSize(this.size.width, this.size.height);
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

      //Grid & Axis
        const grid = new GridHelper(100, 100);
        //Grid on other layer so that it is not clickable. Otherwise problem for set pivot point on double click
        grid.layers.set(1);
        grid.rotateX(Math.PI / 2); 
        this.scene.add(grid);
        const axes = new AxesHelper(50);
        //Axis on other layer so that it is not clickable
        axes.layers.set(1);
        axes.material.depthTest = false;
        axes.renderOrder = 1;
        this.scene.add(axes);
        // console.log(axes);
        // All camera layers visible, but only 0 clickable
        this.camera.layers.set(0);
        this.camera.layers.enable(1);

      //Orbit Controls with TAKTing Turnpoint Object
      this.initializeOrbitControls();
      // console.log(this.sphereGroup);
      
      //Animation loop, continuous update
      const animate = () => {
        // var delta = clock.getDelta();
        // this.controls.update(delta);
        // renderer.clear();
        requestAnimationFrame(animate);
        this.renderer.render(this.scene, this.camera);
        // console.log('Animation Frame');

        // Sync position turnpoint group with actual turnpoint (controls.target)
        if (this.sphereGroup) {
          this.sphereGroup.position.copy(this.controls.target);
          if (this.model_is_loading) {
            this.sphereGroup.rotation.z -= 0.05
            this.sphereGroup.rotation.x += 0.01;
          }
        }
      };

      animate();

      //Raycaster
        this.mouse = new THREE.Vector2();
        this.raycaster = new THREE.Raycaster();
        this.raycaster.firstHitOnly = true;
        this.raycaster.params.Line.threshold = 0.1;
        this.raycaster.params.Points.threshold = 0.1;
      
      // Adjust the viewport to the size of the browser
      // window.addEventListener("resize", () => {
      //   (this.size.width = window.innerWidth), (this.size.height = window.innerHeight);
      //   // this.size.width = this.$refs.canvas.offsetWidth,
      //   // this.size.height = this.$refs.canvas.offsetHeight,

      //   // Methode passt nicht zur Preview Situation!
      //   // this.size.width = content_el.clientWidth;
      //   // this.size.height = content_el.clientHeight;
      //   this.camera.aspect = this.size.width / this.size.height;
      //   this.camera.updateProjectionMatrix();
      //   this.renderer.setSize(this.size.width, this.size.height);
      //   console.log('Event "resize" in IfcInitializePreview.mixin.js registered');
      // });

      // Adjust the viewport to the size of the browser
      /**
       * Adjust the viewport to the variable Hight of the parent div "bim-preview-background".
       * Aspect Ration 16:9 is set.
       *  */  
      let parent_div = document.getElementById("bim-preview-background");
      window.addEventListener("resize", () => {  
        this.size.height = parent_div.clientHeight;
        // console.log(`parent_div.clientHeight: ${parent_div.clientHeight}`);
        if (parent_div.clientWidth > this.size.height / 9 * 16) {
          this.size.width = this.size.height / 9 * 16
        }
        else {
          this.size.width = parent_div.clientWidth
        }
        // console.log(`${this.size.width} x ${this.size.height}`);
        this.camera.aspect = this.size.width / this.size.height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.size.width, this.size.height);
        // console.log('Event "resize" in IfcInitializePreview.mixin.js registered');
      });

      // content_el.addEventListener('resizetabs', () => {
      //   this.size.width = this.$refs.canvas.offsetWidth,
      //   this.size.height = this.$refs.canvas.offsetHeight,

      //   // this.size.width = content_el.clientWidth;
      //   // this.size.height = content_el.clientHeight;
      //   this.camera.aspect = this.size.width / this.size.height;
      //   this.camera.updateProjectionMatrix();
      //   this.renderer.setSize(this.size.width, this.size.height);
      //   console.log('Event "resizetabs" in IfcInitializePreview.mixin.js registered');
      // });
      
      //register event listener for model
      /*
      content_el.addEventListener('mousedown', (event) => {
        this.modelMouseDown(event);
      });
      content_el.addEventListener('mouseup', (event) => {
        this.modelMouseUp(event);
      });
      content_el.addEventListener('mousemove', (event) => {
        this.modelMouseMove(event);
      });
      // register keyboard inputs on window
      window.addEventListener( 'keyup', (event) => {
         this.modelKeyUp(event);
      });
      window.addEventListener( 'keydown', (event) => {
         this.modelKeyDown(event);
      });
      window.addEventListener('mousedown', () => {
        this.window_mouse_down = true;
      });
      window.addEventListener('mouseup', () => {
        this.window_mouse_down = false;
      });
      */
      console.log('Scene successfully initialized');
    },

    sceneLoadModels(takting_ids) {
      console.log('start sceneLoadModels');
      let loader = new GLTFLoader();
      let dracoLoader = new DRACOLoader();
      // dracoLoader.setDecoderPath('http://localhost:8081/files/draco/');
      dracoLoader.setDecoderPath(process.env.VUE_APP_DRACO);
      loader.setDRACOLoader(dracoLoader);

      this.initializeGroups();

      // unstaged handling
      // this.project.unstaged_elements.forEach(id => {
      //   // console.log(id);
      //   this.initializeUnstagedElement(id);
      // });


      //Plan handling
      // let plan_promises = [];
      // Object.keys(this.$store.state.Ultra.plans).forEach(id => {
      //   plan_promises.push(this.initializePlan(id));
      // });
      // //Alle Pläne (2D?) initialsieren und erst anschließend zu GLB Handling übergehen
      // //Für Preview ggf auslassen
      // Promise.all(plan_promises).then(() => {

        // glb handling
        let glb_promises = [];

        let project = this.getUObject({type: 'projects', id: this.$route.params.project_id});
        // console.log(project);

        // one glb for one site -> Site = GLB
        // Iterate over all sites and add loaded DracoGLB to 'glb_promises'.
        project.sites.forEach(id => {
          glb_promises.push(this.loadDracoGLB({ loader: loader, site_id: id }));
        });
        // console.log(glb_promises);
        // Complete all GLB promises (regardless of status) and return results in 'resps'.
        Promise.allSettled(glb_promises).then(resps => {

          // itereate over glbs
          resps.forEach(resp => {
            // Check for fulfilled Promise (resps)
            if (resp.status === 'fulfilled') {

              let meshes = [];
              let edges_meshes = [];
              resp.value.gltf.scene.children.forEach(child => {
                // Add children to the respective GLTF scene depending on the type of the corresponding mesh variable
                if (child.type === 'Mesh') {
                  meshes = [child];
                } else if (child.type === 'Object3D') {
                  edges_meshes = child.children;
                } else if (child.type === 'Group') {
                  meshes = child.children;
                }
              });

              // edges meshes
              edges_meshes.forEach(mesh => {
              // clipping
              mesh.material.clippingPlanes = this.clipping_planes;
              // save mesh names
              this.edges_mesh_names.push(`_edges_site_${resp.value.site_id}_${mesh.name}`);
              // edges
              // visible
              let visible_edges_mesh = mesh.clone();
              visible_edges_mesh.renderOrder = 50;
              visible_edges_mesh.name = `visible_edges_site_${resp.value.site_id}_${mesh.name}`;
              this.visible_edges_group.add(visible_edges_mesh);

              // colored edges for collection
              ['selected', 'highlighted', 'step_elements', 'taktarea_elements'].forEach((collection_type, index) => {
                let collection_edges_geometry = mesh.geometry.clone();
                collection_edges_geometry.setIndex(new BufferAttribute(Uint32Array.from([]), 1));
                let collection_edges_mesh = new THREE.LineSegments(collection_edges_geometry, this.edges_materials[collection_type]);
                collection_edges_mesh.renderOrder = (60 + (index*10));
                collection_edges_mesh.name = `${collection_type}_edges_site_${resp.value.site_id}_${mesh.name}`;
                // console.log(collection_type);
                // console.log(this[`${collection_type}_edges_group`]);
                this[`${collection_type}_edges_group`].add(collection_edges_mesh);
              })
              // //selected
              // let selected_edges_geometry = mesh.geometry.clone();
              // selected_edges_geometry.setIndex(new BufferAttribute(Uint32Array.from([]), 1));
              // let selected_edges_mesh = new THREE.LineSegments(selected_edges_geometry, this.highlight_material_edges);
              // selected_edges_mesh.renderOrder = 60;
              // selected_edges_mesh.name = `selected_edges_site_${resp.value.site_id}_${mesh.name}`;
              // this.selected_edges_group.add(selected_edges_mesh);
              // //highlighted
              // let highlighted_edges_geometry = mesh.geometry.clone();
              // highlighted_edges_geometry.setIndex(new BufferAttribute(Uint32Array.from([]), 1));
              // let highlighted_edges_mesh = new THREE.LineSegments(highlighted_edges_geometry, this.highlight_material_edges);
              // highlighted_edges_mesh.renderOrder = 70;
              // highlighted_edges_mesh.name = `highlighted_edges_site_${resp.value.site_id}_${mesh.name}`;
              // this.highlighted_edges_group.add(highlighted_edges_mesh);
              
              // element selection
              let element_selection_geometry = mesh.geometry.clone();
              element_selection_geometry.setIndex(new BufferAttribute(Uint32Array.from([]), 1));
              let element_selection_mesh = new THREE.LineSegments(element_selection_geometry, this.element_selection_material);
              element_selection_mesh.renderOrder = 80;
              element_selection_mesh.name = `element_selection_edges_site_${resp.value.site_id}_${mesh.name}`;
              this.element_selection_group.add(element_selection_mesh);

              // points test
              // this.points_helper_group.add(new THREE.Points( mesh.geometry.clone()));
              // edges helper
              // console.log('start edge helper');
              // this.edges_helper_group.add(this.createEdgesHelperMesh(mesh.geometry));
              // console.log('end edge helper');

              // points test
              // console.log('points start');
              // this.points_helper_group.add(this.createPointsHelperMesh(mesh.geometry));
              // console.log('points end');

              });

              // copy meshes
              meshes.forEach((mesh, mesh_index) => {
                // console.log(mesh);
                // console.log(mesh_index);
                this.mesh_names.push(`_normal_site_${resp.value.site_id}_${mesh.name}`);
                // transparent_group
                let transparent_geometry = mesh.geometry.clone();
                let transparent_mesh = new Mesh(transparent_geometry, this.transparent_material);
                transparent_mesh.renderOrder = 0;
                transparent_mesh.name = `transparent_normal_site_${resp.value.site_id}_${mesh.name}`;
                this.transparent_group.add(transparent_mesh);
                // visible mesh
                let visible_mesh = mesh.clone();
                visible_mesh.renderOrder = 10;
                visible_mesh.name = `visible_normal_site_${resp.value.site_id}_${mesh.name}`;
                this.visible_normal_group.add(visible_mesh);
                
                
                let visible_geometry = mesh.geometry.clone();
                // back
                let mat_back = mesh.material.clone();
                mat_back.depthWrite = false;
                mat_back.depthTest = false;
                mat_back.colorWrite = false;
                mat_back.stencilWrite = true;
                mat_back.stencilFunc = THREE.AlwaysStencilFunc;
                mat_back.side = THREE.FrontSide;

                mat_back.stencilFail = THREE.IncrementStencilOp;
                mat_back.stencilZFail = THREE.IncrementStencilOp;
                mat_back.stencilZPass = THREE.IncrementStencilOp;

                // mat_back.stencilRef = mesh_index+1;
                // mat_back.stencilFail = THREE.ReplaceStencilOp;
                // mat_back.stencilZFail = THREE.ReplaceStencilOp;
                // mat_back.stencilZPass = THREE.ReplaceStencilOp;

                // mat_back.side = THREE.BackSide;
                // // mat_back.colorWrite = false;
                // mat_back.depthWrite = false;
                // mat_back.stencilWrite = true;
                // mat_back.stencilRef = mesh_index;
                // mat_back.stencilFunc = THREE.AlwaysStencilFunc;
                // mat_back.stencilZPass = THREE.ReplaceStencilOp;

                // // mat_back.stencilFunc = THREE.EqualStencilFunc;
                // // // mat_back.stencilFail = THREE.DecrementWrapStencilOp;
                // // // mat_back.stencilZFail = THREE.DecrementWrapStencilOp;
                // // // mat_back.stencilZPass = THREE.DecrementWrapStencilOp;
                // // // mat_back.stencilWriteMask = mesh_index.toString(16);
                
                mat_back.clippingPlanes = this.clipping_planes;
                let visible_geometry_mesh_back = new Mesh(visible_geometry, mat_back);
                visible_geometry_mesh_back.name = mesh_index;
                visible_geometry_mesh_back.renderOrder = (mesh_index + 1) * 10;
                // this.all_groups.add(visible_geometry_mesh_back);


                // front 
                let mat_front = mesh.material.clone();
                mat_front = new THREE.MeshBasicMaterial();
                mat_front.depthWrite = false;
                mat_front.depthTest = false;
                mat_front.colorWrite = false;
                mat_front.stencilWrite = true;
                mat_front.stencilFunc = THREE.AlwaysStencilFunc;
                mat_front.side = THREE.BackSide;


                mat_front.stencilFail = THREE.DecrementStencilOp;
                mat_front.stencilZFail = THREE.DecrementStencilOp;
                mat_front.stencilZPass = THREE.DecrementStencilOp;

                // mat_front.stencilRef = mesh_index+1;
                // mat_front.stencilFail = THREE.ReplaceStencilOp;
                // mat_front.stencilZFail = THREE.ReplaceStencilOp;
                // mat_front.stencilZPass = THREE.ReplaceStencilOp;

                // mat_front.stencilFail = THREE.ZeroStencilOp;
                // mat_front.stencilZFail = THREE.ZeroStencilOp;
                // mat_front.stencilZPass = THREE.ZeroStencilOp;



                // mat_front.side = THREE.FrontSide;
                // mat_front.stencilWrite = true;
                // mat_front.stencilFail = THREE.IncrementWrapStencilOp;
                // mat_front.stencilZFail = THREE.IncrementWrapStencilOp;
                // mat_front.stencilZPass = THREE.IncrementWrapStencilOp;
                // // mat_front.stencilRef = 1;
                // mat_front.stencilWriteMask = mesh_index.toString(16);
                
                mat_front.clippingPlanes = this.clipping_planes;
                let visible_geometry_mesh_front = new Mesh(visible_geometry, mat_front);
                visible_geometry_mesh_front.name = mesh_index;
                visible_geometry_mesh_front.renderOrder = (mesh_index + 1) * 10 + 1;
                // this.all_groups.add(visible_geometry_mesh_front);
                

                //selected
                let selected_geometry = mesh.geometry.clone();
                selected_geometry.setIndex(new BufferAttribute(Uint32Array.from([]), 1));
                let selected_mesh = new Mesh(selected_geometry, this.highlight_material);
                selected_mesh.renderOrder = 20;
                selected_mesh.name = `selected_normal_site_${resp.value.site_id}_${mesh.name}`;
                this.selected_normal_group.add(selected_mesh);
                //highlighted
                let highlighted_geometry = mesh.geometry.clone();
                highlighted_geometry.setIndex(new BufferAttribute(Uint32Array.from([]), 1));
                let highlighted_mesh = new Mesh(highlighted_geometry, this.highlight_material);
                highlighted_mesh.renderOrder = 30;
                highlighted_mesh.name = `highlighted_normal_site_${resp.value.site_id}_${mesh.name}`;
                this.highlighted_normal_group.add(highlighted_mesh);
                // console.log(this.transparent_material);
                // console.log(this.highlight_material);
              });// End meshes.forEach
              // console.log(`meshes: ${meshes}`);
              // console.log(meshes);
              // console.log(`edges_meshes: ${edges_meshes}`);
              // console.log(edges_meshes);
            }//End if resp = fullfilled

          }); // End Iteration over glbs (resps.forEach)
          console.log('success loading glb');
          // console.log(resps);
          console.log(this.scene);
          // console.log(this.scene.children);

          this.all_groups.rotateX( Math.PI / 2);
          this.scene.add(this.all_groups);
          this.setCollectionObjects({collection_name: 'visible_elements', action: 'set', ids_by_target: {elements: Object.keys(this.$store.state.ProjectStructure.project_elements)}});
          this.raycast_object = this.scene.getObjectByName('visible_normal_group');
          this.instantiateElements();
          this.model_is_loading = false;

          // Set visibilities based on the elements of the taktarea
          console.log(takting_ids);
          this.highlightElementsShowRestTransparent(takting_ids);
          this.camera.position.set(0, 0, 10);
          this.zoomToVisible(this.camera, this.all_groups);
          // this.initializeClipping();
        }); // End Promise.allSettled
        console.log('sceneLoadModels finished');
    },// End sceneLoadModels


    /**
     * Creates the orbit controls as well as the corporate turnpoint object.
     * Adds a double-click event listener for the definition of the turnpoint.
     * Connects the position of the turnpoint object with controls.target
     */
    initializeOrbitControls() {
      //Creates the orbit controls (to navigate the scene)
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = false;
      this.controls.enablePan = true;
      this.controls.enableRotate = true;
      this.controls.enableZoom = true;

      //Display turnpoint using corporate turnpoint object     
      //TAKT.ing colors for turnpoint sphere
      const colors = [
        "#000000",
        "#000000",
        "#424242",
        "#843C0C",
        "#942093",
        "#941651",
        "#FF2600",
        "#FF7E79",
        "#FF9300",
        "#FFFC00",
        "#8EFA00",
        "#00FA00",
        "#00FB92",
        "#00FDFF",
        "#0096FF",
        "#0432FF",
        "#000000",
        "#000000",
      ];
      const radius = 0.25;
      const segments = 32;
      this.sphereGroup = new Group();
      this.sphereGroup.name = "OrbitTarget";

      // Latitudes
      colors.forEach((color, index) => {
        const phi = (index / (colors.length - 1)) * Math.PI;
        const ringGeometry = new BufferGeometry().setFromPoints(
          Array.from({ length: segments + 1 }, (_, i) => {
            const theta = (i / segments) * 2 * Math.PI;
            const vertex = new Vector3();
            vertex.setFromSphericalCoords(radius, phi, theta);
            return vertex;
          })
        );
        const material = new LineBasicMaterial({ color: color });
        const ring = new LineLoop(ringGeometry, material);
        this.sphereGroup.add(ring);
      });
      // Longitudes
      // colors.forEach((color, index) => {
      //   const theta = (index / (colors.length - 1)) * 2 * Math.PI;
      //   const longitudeGeometry = new BufferGeometry().setFromPoints(
      //       Array.from({ length: segments + 1 }, (_, i) => {
      //           const phi = (i / segments) * Math.PI;
      //           const vertex = new Vector3();
      //           vertex.setFromSphericalCoords(radius, phi, theta);
      //           return vertex;
      //       })
      //   );
      //   const material = new LineBasicMaterial({ color: color });
      //   const longitude = new Line(longitudeGeometry, material);
      //   this.sphereGroup.add(longitude);
      // });

      this.scene.add(this.sphereGroup);
      // console.log(this.scene); 

      // Set the initial position of the sphere to the current turnpoint of OrbitControls
      this.sphereGroup.position.copy(this.controls.target);

      // Double-click event listener for definition of the turnpoint
      this.renderer.domElement.addEventListener('dblclick', (event) => {
        const canvasBounds = this.$refs.canvas.getBoundingClientRect();
        const mouseX = event.clientX - canvasBounds.left;
        const mouseY = event.clientY - canvasBounds.top;
        const mouse = new THREE.Vector2(
          (mouseX / this.$refs.canvas.offsetWidth) * 2 - 1,
          -(mouseY / this.$refs.canvas.offsetHeight) * 2 + 1
        );
        // console.log(`Fensterbreite: ${this.$refs.canvas.offsetWidth} und Fensterhöhe: ${this.$refs.canvas.offsetHeight}`);
        // const raycaster = new THREE.Raycaster();
        this.raycaster.setFromCamera(mouse, this.camera);
        // const intersects = raycaster.intersectObjects(resp.value.gltf.scene);
        const intersects = this.raycaster.intersectObjects(this.scene.children, true);
        // const intersects = this.raycaster.intersectObjects(this.raycast_object, true);

        console.log(this.scene.children);
        console.log(intersects);
        if (intersects.length > 0) {
          const intersectionPoint = intersects[0].point;

          // Update the position of the sphere and the turnpoint of OrbitControls
          this.sphereGroup.position.copy(intersectionPoint);
          this.controls.target.copy(intersectionPoint);
          this.controls.update();
        }
        console.log('dblclick');
      });
      console.log('OrbitControls initialized');
    },


    /**
     * Compresses a given GLB to a DracoGLB (GLTF)
     * Documentation: https://threejs.org/docs/#examples/en/loaders/GLTFLoader
     * @param {Object} payload - The payload object with the required information.
     * @param {Object} payload.loader - The loader used to load the GLB model.
     * @param {string} payload.site_id - The site ID used to create the resource URL.
     * @returns {Promise<Object>} A Promise that resolves on successful load with an object containing the `site_id` 
     *                            and the loaded `gltf`. If an error occurs the Promise is rejected with an error.
    */
    loadDracoGLB(payload) {
      // console.log(`Payload for loadDracoGLB:`);
      // console.log(payload);
      return new Promise((resolve, reject) => {
        //GLB URL
        const url = `${process.env.VUE_APP_IFC_GLB_URL}/${this.$route.params.project_id}_${payload.site_id}.glb`;
        // console.log(url);
        payload.loader.load(
          // resource URL
          url,
          // called when the resource is loaded
          function ( gltf ) {
            resolve({site_id: payload.site_id, gltf: gltf});
          },
          // called while loading is progressing (optional)
          function ( xhr ) {
            console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );
          },
          // called when loading has errors (optional)
          function ( error ) {
            reject(new Error(`Error in loadDracoGLB: ${error.message || 'Unknown error'}`));
          }
        );
      });
    },


    /**
    * Zooms the camera to fit the visible objects within the scene.
    * @param {THREE.Camera} camera - The camera object from the Three.js scene.
    * @param {THREE.Mesh|THREE.Group|Array} objects - The object(s) to focus on. Can be a single object or an array of objects. e.g. this.all_groups
    * @param {number} baseOffset - The base offset to apply when positioning the camera. Default is 3.
    */
    zoomToVisible(camera, objects, baseOffset = 5) {
      // Convert the input to an array if it's not already an array
      if (!Array.isArray(objects)) {
        objects = [objects];
      }

      // Create a new bounding box to calculate the dimensions of the objects
      const boundingBox = new THREE.Box3();

      // Loop through each object and update the bounding box dimensions
      for (let object of objects) {
        if (object instanceof THREE.Mesh || object instanceof THREE.Group) {
          // Update the world matrix of the object if needed
          if (object.updateWorldMatrix) {
            object.updateWorldMatrix(true, false);
          }
          // Expand the bounding box to include the object
          boundingBox.expandByObject(object);
        }
      }

      // Calculate the center point of the bounding box
      const center = boundingBox.getCenter(new THREE.Vector3());
      const size = boundingBox.getSize(new THREE.Vector3());

      // Get the maximum dimension (radius) of the objects
      const maxDim = Math.max(size.x, size.y, size.z);
      const fov = camera.fov * (Math.PI / 180);

      // Calculate the optimal Z position of the camera
      let cameraZ = Math.abs(maxDim / (2 * Math.tan(fov / 2)));

      // Apply a dynamic offset to the camera's Z position
      cameraZ += baseOffset;

      // Calculate the new position of the camera while maintaining the current orientation
      const dir = camera.position.sub(center).normalize();
      const newPosition = dir.multiplyScalar(cameraZ).add(center);

      // Update the camera's position
      camera.position.copy(newPosition);

      // Update the OrbitControls if they exist
      if (this.controls) {
        this.controls.target.copy(center);
        this.controls.update();
      }
    },
  

    /**
     * Links the shortcut Z with the function zoomToVisible
     * @param {*} event 
     */
    onKeyDown(event) {
      if (event.key === 'Z' || event.key === 'z') {
        // const objectsToConsider = this.scene.children.filter(child => 
        //   child instanceof THREE.Mesh 
        //   //|| child instanceof THREE.Group
        // );
        const objectsToConsider =  this.scene.getObjectByName('all_groups')
        // this.scene.getObjectByName('all_groups')
        
        // console.log("objectsToConsider:");
        // console.log(objectsToConsider);
        this.zoomToVisible(this.camera, objectsToConsider);
        // console.log('Shortcut "Z" registriert');
      }
    },

    /**
     * Initializes the groups for all_groups, transparent, plans, pointer-helper, edges_helper, collection_type,
     *and the ${type}_groups and sets preset visibilities
     */
    initializeGroups() {
      // initialize groups
      // group for all groups
      this.all_groups = new Group();
      this.all_groups.name = "all_groups";

      // transparent
      this.transparent_group = new Group();
      this.transparent_group.name = 'transparent_group';
      this.transparent_group.visible = false;
      this.all_groups.add(this.transparent_group);

      // plans
      this.plans_group = new Group();
      this.plans_group.name = 'plans_group';
      this.all_groups.add(this.plans_group);
      // points helper
      this.points_helper_group = new Group();
      this.points_helper_group.name = 'points_helper_group';
      this.all_groups.add(this.points_helper_group);
      // edges helper
      this.edges_helper_group = new Group();
      this.edges_helper_group.name = 'edges_helper_group';
      this.edges_helper_group.visible = false;
      this.all_groups.add(this.edges_helper_group);

      // edges collection groups
      ['element_selection', 'step_elements_edges', 'taktarea_elements_edges'].forEach(collection_type => {
        this[`${collection_type}_group`] = new Group();
        this[`${collection_type}_group`].name = `${collection_type}_group`;
        this.all_groups.add(this[`${collection_type}_group`]);
      });
      // console.log('yeahh')
      // // selection group
      // this.element_selection_group = new Group();
      // this.element_selection_group.name = 'element_selection_group';
      // this.all_groups.add(this.element_selection_group);

      // do for edges and normal representation
      let types = ['normal','edges'];
      types.forEach(type => {
        // console.log(type);
        // group for all groups
        this[`all_${type}_groups`] = new Group();
        this[`all_${type}_groups`].name = `all_${type}_groups`;
        this.all_groups.add(this[`all_${type}_groups`]);

        // visible
        this[`visible_${type}_group`] = new Group();
        this[`visible_${type}_group`].name = `visible_${type}_group`;
        if (type === 'edges') {
          this[`visible_${type}_group`].visible = false;
        }
        this[`all_${type}_groups`].add(this[`visible_${type}_group`]);

        // selected
        this[`selected_${type}_group`] = new Group();
        this[`selected_${type}_group`].name = `selected_${type}_group`;
        if (type === 'edges') {
          this[`selected_${type}_group`].visible = false;
        }
        this[`all_${type}_groups`].add(this[`selected_${type}_group`]);

        // highlighted
        this[`highlighted_${type}_group`] = new Group();
        this[`highlighted_${type}_group`].name = `highlighted_${type}_group`;
        if (type === 'edges') {
          this[`highlighted_${type}_group`].visible = false;
        }
        this[`all_${type}_groups`].add(this[`highlighted_${type}_group`]);
      });
      console.log('Groups initialized');
    },

    initializeMaterials() {
      this.highlight_material = new MeshLambertMaterial({
        color: 0xff0000,
        side: DoubleSide,
        clippingPlanes: this.clipping_planes,
        
        stencilWrite: true,
				stencilFail: THREE.IncrementWrapStencilOp,
				stencilZFail: THREE.IncrementWrapStencilOp,
				stencilZPass: THREE.IncrementWrapStencilOp,
      });
      this.highlight_material_edges = new THREE.LineBasicMaterial( { 
        color: 0xff0000,
        clippingPlanes: this.clipping_planes,
      } )
      this.element_selection_material = new THREE.LineBasicMaterial( { 
        color: 0xFF9900,
        clippingPlanes: this.clipping_planes,
      } )
      // edges materials
      this.edges_materials = {};
      this.edges_materials.selected = new THREE.LineBasicMaterial( { 
        color: 0xff0000, //red
        clippingPlanes: this.clipping_planes,
      } )
      this.edges_materials.highlighted = new THREE.LineBasicMaterial( { 
        color: 0xff0000, //red
        clippingPlanes: this.clipping_planes,
      } )
      this.edges_materials.element_selection = new THREE.LineBasicMaterial( { 
        color: 0xFF9900, //orange
        clippingPlanes: this.clipping_planes,
      } )
      this.edges_materials.step_elements = new THREE.LineBasicMaterial( { 
        color: 0x0000FF, //blue
        clippingPlanes: this.clipping_planes,
      } )
      this.edges_materials.taktarea_elements = new THREE.LineBasicMaterial( { 
        color: 0xc90076, //magenta
        clippingPlanes: this.clipping_planes,
      } )

      this.points_material = new THREE.PointsMaterial( { size: 5, color: 0x888888 } );
      this.transparent_material = new MeshLambertMaterial({color: new Color('blue')});
      this.transparent_material.opacity = 0.15;
      this.transparent_material.transparent = true;

      this.shape_material = new MeshLambertMaterial({
        color: 0xff0000,
        side: DoubleSide,
        opacity: 0.2,
        transparent: true
      });

      BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
      BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
      Mesh.prototype.raycast = acceleratedRaycast;
      // THREE.LineSegments.prototype.raycast = acceleratedRaycast;
      console.log('Materials initialized');
    },

    /**
     * Copied from IfcInitializeMixin.js.
     * Loops through all children of the visible_normal_group via the takting_id.
     * Fills this.elements_by_takting_id as well as this.edges_elements_by_takting_id.
     */
    instantiateElements() {
      //reset elements
      // console.log(this.elements_by_takting_id);
      this.elements_by_takting_id = {};
      this.scene.getObjectByName('visible_normal_group').traverse(el => {
        if (el.geometry && !el.unstaged) {
          el.geometry.computeBoundsTree();
          el.geometry.index.array.forEach(ind => {
            let takting_id = el.geometry.attributes['_takting_id'].array[ind];
            if (this.elements_by_takting_id[takting_id]) {
              let subelement = this.elements_by_takting_id[takting_id].find(subel => subel.mesh === el.name.substring(14));
              if (subelement) {
                subelement.array.push(ind);
              } else {
                this.elements_by_takting_id[takting_id].push({mesh: el.name.substring(14), array: [ind]});
              }
              // this.elements_by_takting_id[takting_id].array.push(ind);
            } else {
              this.elements_by_takting_id[takting_id] = [{mesh: el.name.substring(14), array: [ind]}];
              // this.elements_by_takting_id[takting_id] = {mesh: el.name, array: [ind]};
            }
          });
        }
      });
      // edges
      this.edges_elements_by_takting_id = {};
      this.scene.getObjectByName('visible_edges_group').traverse(el => {
        if (el.geometry && !el.unstaged) {
          // el.geometry.computeBoundsTree();
          el.geometry.index.array.forEach(ind => {
            let takting_id = el.geometry.attributes['_takting_id'].array[ind];
            if (this.edges_elements_by_takting_id[takting_id]) {
              let subelement = this.edges_elements_by_takting_id[takting_id].find(subel => subel.mesh === el.name.substring(13));
              if (subelement) {
                subelement.array.push(ind);
              } else {
                this.edges_elements_by_takting_id[takting_id].push({mesh: el.name.substring(13), array: [ind]});
              }
            } else {
              this.edges_elements_by_takting_id[takting_id] = [{mesh: el.name.substring(13), array: [ind]}];
            }
          });
        }
      });
      // console.log(this.scene.getObjectByName('visible_normal_group'));
      // console.log(this.scene);
      // console.log(this.elements_by_takting_id);
      // console.log(JSON.stringify(this.elements_by_takting_id));

    },

    /**
     * Elements with the given takting_ids are highlighted by displaying them via indices in the existing group 
     * "highlighted_normals". All other existing IDs, except the given takting_ids, are displayed transparently by showing them via indices in the 
     * existing "transparent_normals" group.
     * @param {Array} takting_ids - Array of takting IDs of IFC elements
     */
    highlightElementsShowRestTransparent(takting_ids) {
      // let prefix_mesh = "visible_normal"
      const Hilfsobjekt_by_mesh = this.createHilfsobjekt(takting_ids);
      // console.log(Hilfsobjekt_by_mesh);

      Object.keys(Hilfsobjekt_by_mesh).forEach(mesh => {
        // console.log(Hilfsobjekt_by_mesh[mesh]);
        if (Hilfsobjekt_by_mesh[mesh]) {
          // console.log("Hilfsobjekt Mesh = true");
          this.scene.getObjectByName("visible_normal_group").visible = false;
          
          // Show given elements in highlighted-normal group via Geometry/Index
          let highlightedMesh = this.scene.getObjectByName(`highlighted_normal${mesh}`);
    
          if (highlightedMesh && highlightedMesh.geometry && highlightedMesh.geometry.index) {
            highlightedMesh.geometry.setIndex(new BufferAttribute(Uint32Array.from(Hilfsobjekt_by_mesh[mesh].array), 1));
            // highlightedMesh.geometry.index.array = Hilfsobjekt_by_mesh[mesh].array;

            highlightedMesh.geometry.index.needsUpdate = true;
          } else {
            console.warn(`Mesh highlighted_normal${mesh} oder sein Index-Array existiert nicht.`);
          }
          // console.log(highlightedMesh.geometry.index.array);
          // console.log(this.scene.getObjectByName("highlighted_normal_group"));
          this.scene.getObjectByName("highlighted_normal_group").visible = true;


          // Show all other elements in transparent-normal group via Geometry/Index
          let transparentMesh = this.scene.getObjectByName(`transparent_normal${mesh}`);
          if (transparentMesh && transparentMesh.geometry && transparentMesh.geometry.index) {
            // Create a copy of the original index array
            const originalIndexArray = Array.from(transparentMesh.geometry.index.array);
          
            // Remove the indexes that are already present in Hilfsobjekt_by_mesh[mesh].array
            const toRemove = new Set(Hilfsobjekt_by_mesh[mesh].array);
            const filteredArray = originalIndexArray.filter(item => !toRemove.has(item));
          
            // Setting the new index array
            transparentMesh.geometry.setIndex(new THREE.BufferAttribute(new Uint32Array(filteredArray), 1));
          
            // Geometry update
            transparentMesh.geometry.index.needsUpdate = true;
            this.scene.getObjectByName("transparent_group").visible = true;
            this.scene.getObjectByName("visible_edges_group").visible = false;
          } else {
            console.warn(`Mesh transparent_normal${mesh} oder sein Index-Array existiert nicht.`);
          }
        }
      });
      // console.log(this.scene);
      // this.scene.getObjectByName("transparent_group").visible = true;
      // console.log(this.scene.getObjectByName("highlighted_normal_group"));

    },


    /**
     * Blendet ein komplettes Mesh aus, indem geometry.index.array auf 0 gesetzt wird.
     */
    testHideMeshWithIndizes() {
      const indexArrayToHide = this.scene.getObjectByName("visible_normal_site_1133_mesh_0_1").geometry.index.array;
      // eine tiefe Kopie des Arrays erstellen
      const indexArrayCopy = Array.from(indexArrayToHide);
      console.log(this.scene.getObjectByName("visible_normal_site_1133_mesh_0_1"));
      console.log(indexArrayToHide);
      
      for (let i = 0; i < indexArrayToHide.length; i++) {
        indexArrayToHide[i] = 0;
      }
      // console.log(this.scene);

      // Statt visible_Mesh transparent_Mesh setzen
      let indexArrayToShowTransparent = this.scene.getObjectByName("transparent_normal_site_1133_mesh_0_1").geometry.index.array;
      for (let i = 0; i < indexArrayToShowTransparent.length; i++) {
        indexArrayToShowTransparent[i] = 0;
      }
      for (let i = 0; i < indexArrayCopy.length; i++) {
        indexArrayToShowTransparent[i] = indexArrayCopy[i];
      }
      console.log(this.scene);
      console.log(indexArrayToShowTransparent);
      // this.scene.getObjectByName("transparent_group").visible = true;
    },

    /**
     * Erzeugt ein Hilfsobjekt indem ein Array aus IDs eingegeben wird
     * und this.elements_by_takting_id umgebaut wird in ein Objekt das als Schlüssel die Mesh-Namen beinhaltet und darunter das Index Array. 
     * @param {Array} takting_ids - Array aus Takting IDs der IFC Elemente 
     * @returns {Object} hilfsobjekt
     */
    createHilfsobjekt(takting_ids) {
      const hilfsobjekt = {};
  
      takting_ids.forEach(id => {
          if (this.elements_by_takting_id[id]) {
            this.elements_by_takting_id[id].forEach(element => {
                  if (!hilfsobjekt[element.mesh]) {
                      hilfsobjekt[element.mesh] = {
                          array: []
                      };
                  }
                  hilfsobjekt[element.mesh].array = hilfsobjekt[element.mesh].array.concat(element.array);
              });
          }
      });
      return hilfsobjekt;
    },

    initializeUnstagedElement(id) {
      let element = this.$store.state.Ultra.elements[id];
      console.log(element);
      let unstaged_geometry = this.createUnstagedGeometry(element.geometry);
      if (unstaged_geometry) {
        // transparent
        let transparent_mesh = this.createUnstagedGeometryMesh(unstaged_geometry, element, this.transparent_material, 'transparent');
        transparent_mesh.renderOrder = 0;
        this.transparent_group.add(transparent_mesh);
        // visible
        let visible_mesh = this.createUnstagedGeometryMesh(unstaged_geometry, element, this.shape_material, 'visible');
        visible_mesh.renderOrder = 10;
        this.visible_normal_group.add(visible_mesh);
        // selected
        let selected_mesh = this.createUnstagedGeometryMesh(unstaged_geometry, element, this.highlight_material, 'selected');
        selected_mesh.renderOrder = 20;
        selected_mesh.visible = false;
        this.selected_normal_group.add(selected_mesh);
        // highlighted
        let highlighted_mesh = this.createUnstagedGeometryMesh(unstaged_geometry, element, this.highlight_material, 'highlighted');
        highlighted_mesh.renderOrder = 30;
        highlighted_mesh.visible = false;
        this.highlighted_normal_group.add(highlighted_mesh);
      }
    },
  },
};